<template>
    <div class="landing-lloyds">
        <div class="header">

            <div class="container mobile">

                <div class="row logo-header">

                    <img class="lloyds" src="@/assets/images/icons/lloyds-horse.svg" />
                    <img class="compitacenter" src="@/assets/images/icons/compitacenter.svg" />
                </div>
            </div>

        </div>
        <section class="banner-lloyd">
            <div class="banner-wraper">
                <div class="image" src="@/assets/images/page/home-lloyds.jpg?" />
                <div class="btn-wraper">
                    <h2>Welcome to LBG – Smart Buildings</h2>
                    <hr>
                    <div class="cta-button"
                    v-on:click="setActiveEnv(2)"
                    >Enter Environment</div>
                </div>
 
            </div>
        </section>
        <section class="info-lloyd" v-if="false">
            <div class="container">
                <div class="row">
                    <h2>Welcome to the Lloyds Digital Workplace</h2>
                    <hr>
                </div> 
                <div v-if="false">
                    <h3>Lloyds Banking Group</h3>
                    <h1>Finance reinvented</h1>
                    <div class="details">The Post Office for the future has a clearly defines strategy for success. This vision is
                        referred to as the ‘Strand to Future Success’ as outlined by our CEO XXXXXXXXXXXX. The 7 pillars
                        that are the foundation for success are symbolised through these icons. These icons will be
                        accredited to technology deployed across our Post Office that aligns with, and delivers on out
                        future strategy. </div>
                        <hr>

                </div>
            </div>
        </section>
        <section class="footer">
            <div class="container">

                <div class="row">
                    ©2016 - 2023 Computacenter (UK) Ltd
                </div>
            </div>
        </section>

    </div>
</template>

<script>
import HeroSection from '@/components/landing/HeroSection.vue'
import HeroSection2 from '@/components/landing/HeroSection2.vue'
import EnvHomeSection from '@/components/landing/EnvHomeSection.vue'

export default {
    name: 'Landing',
    components: {
        HeroSection, HeroSection2, EnvHomeSection
    },
    props: ['selectEnvironments', 'envListImages'],
    data() {
        return {
        }
    },
    mounted() {
    },
    computed: {
            envList: function () {
                let envList = [];
                this.globalData.environments.forEach((item, i) => {
                    // if (this.selectEnvironments.indexOf(item.id) != -1) {
                    //     if (item.slug == 'groupbank') {
                    //         this.globalData.environments.forEach((subEnv, i) => {
                    //             if (subEnv.parent == item.id) {
                    //                 envList.push(subEnv)
                    //             }
                    //         });
                    //     } else {
                    //         envList.push(item)
                    //     }
                    if (item.grouptype) {
                        // this.globalData.environments.forEach((subEnv, i) => {
                        //     if (subEnv.parent == item.id) {
                        //         envList.push(subEnv)
                        //     }
                        // });
                    } else {
                        envList.push(item)
                    }
                    // }
                });
                return envList;
            }
        },
    methods: {
        setActiveEnv(id) {

            this.$emit('setActiveEnv', id);
                this.$router.push({name: 'Environments'});
        },

        addEnv(id) {
            this.$emit('addEnv', id)
        },
        removeEnv(id) {
            this.$emit('removeEnv', id)
        },
    }

}
</script>
